<template>
    <vx-card id="loader">
        <div class="mb-6">
            <div class="vx-row">
                <div class="vx-col w-1/2">
                    <h3>Изменение домена объявлений рекламодателей</h3>
                </div>
            </div>

            <div class="vx-row mt-2">
                <div class="vx-col w-1/4">
                    <div class="mt-1">
                        <vs-input
                            v-model="form.adId"
                            autocomplete="off"
                            type="number"
                            min="0"
                            label="Введите id объявления"
                            class="mt-1 w-full required"/>
                    </div>
                </div>
                <div class="vx-col w-1/2">
                    <vs-button class="mt-6" color="success" @click="getAd()" type="filled">
                        Найти объявление
                    </vs-button>
                </div>
            </div>

            <div class="vx-row mt-2">
                <div class="vx-col w-full">
                    <div>{{ ad.url }}</div>
                </div>
            </div>

            <div class="vx-row mt-2">
                <div class="vx-col w-1/4">
                    <div class="mt-1">
                        <vs-input
                            v-model="form.sourceDomain"
                            autocomplete="off"
                            label="Какой домен заменить (например, example.com)"
                            class="mt-1 w-full required"/>
                    </div>
                </div>
                <div class="vx-col w-1/4">
                    <div class="mt-1">
                        <vs-input
                            v-model="form.targetDomain"
                            autocomplete="off"
                            label="На какой домен заменить (например, example.com)"
                            class="mt-1 w-full required"/>
                    </div>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col w-1/2">
                    <vs-button :disabled="!ad.url" class="mt-6" color="warning" @click="showUpdateModal()" type="filled">
                        Изменить домен
                    </vs-button>
                </div>
            </div>
        </div>

        <div class="mt-6">
            <h4 class="mb-3">Лог изменений</h4>

            <div class="vx-row mb-2">
                <div class="vx-col w-1/4 mb-1">
                    <label class="vs-input--label"> Интервал </label>
                    <date-picker
                        range
                        v-model="dateInterval"
                        type="datetime"
                        format="YYYY-MM-DD-HH:mm:ss"
                        placeholder="Интервал времени события"
                        :lang="'ru'"
                        :firstDayOfWeek="1"
                        class="date-p w-full"
                    >
                    </date-picker>
                </div>
                <div class="vx-col">
                    <vs-button class="mt-5" color="warning" @click="loadLogs()" type="filled">
                        Применить
                    </vs-button>
                </div>
            </div>
        </div>


        <vs-table stripe :data="logs" max-items="50" :sst="true" class="mt-1">
            <template slot="header">
            </template>
            <template slot="thead">
                <vs-th sort-key="attr" class="vs-lg-2">
                    Дата
                </vs-th>
                <vs-th sort-key="sspId" class="vs-lg-2">
                    Пользователь
                </vs-th>
                <vs-th sort-key="coeff" class="vs-lg-4">
                    Старое значение
                </vs-th>
                <vs-th sort-key="coeff" class="vs-lg-4">
                    Новое значение
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{tr.startDateTime | moment('DD.MM.YYYY HH:mm') }}</vs-td>
                    <vs-td>{{tr.userId}}</vs-td>
                    <vs-td>{{tr.oldValue}}</vs-td>
                    <vs-td>{{tr.newValue}}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>


        <sweet-modal ref="updateModal" icon="error" title="Изменение домена">
            <div class="mb-5">Вы действительно хотите заменить домен {{form.sourceDomain}} на {{form.targetDomain}}?</div>

            <vs-button class="" color="warning" @click="updateDomain(selected)" type="filled">
                Изменить
            </vs-button>
        </sweet-modal>
    </vx-card>
</template>


<script>
    import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
    import DatePicker from 'vue2-datepicker';
    import axios from 'axios';

    export default {
        name: 'change-domain',
        data() {
            return {
                ad: {},
                logs: [],
                selected: {},
                form: {
                    adId: '',
                    sourceDomain: '', 
                    targetDomain: '',
                    date_time_from: undefined,
                    date_time_to: undefined,
                },
                dateInterval: undefined,
                page: 1,
                pageSize: 200,
                pagesTotal: 1,
            }
        },
        components: {
            SweetModal,
            SweetModalTab,
            'date-picker': DatePicker
        },
        methods: {
            getAd() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.$axios({
                    url: 'ads/' + this.form.adId,
                    method: 'GET',
                    success: (ad) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.ad = ad;
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Ошибка!",
                            text: "Ошибка при поиске объявления.",
                            color: "danger",
                        });
                    },
                });
            },
            loadLogs() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                const params = {
                    dateFrom: this.form.dateTimeFrom,
                    dateTo: this.form.dateTimeTo,
                    customDataType: 1, // update single
                    page: this.page,
                    size: this.pageSize
                };

                this.axios.all([
                    this.axios.get('logs/ad/change-url', { params }),
                    this.axios.get('logs/ad/change-url/count', { params })
                ])
                .then(axios.spread((logs, count) => {
                    debugger
                    this.logs = logs.data;
                    this.pagesTotal = Math.floor(count.data / this.pageSize) + 1;
                }))
                .catch((err) => {
                    this.$vs.notify({
                        title: "Ошибка!",
                        text: "Ошибка загрузки логов.",
                        color: "danger",
                    });
                })
                .finally(() => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                });
            },
            updateDomain() {
                if (!this.form.adId) {
                    this.$vs.notify({
                        title: "Внимание!",
                        text: "Неободимо указать объявление!",
                        color: "danger",
                    });
                }

                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                const params = {
                    sourceDomain: this.form.sourceDomain,
                    targetDomain: this.form.targetDomain
                };

                this.$axios({
                    method: 'POST',
                    url: 'ads-domain/update/' + this.form.adId,
                    params: params,
                    errors: this.errors,
                    success: (updated) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");

                        this.closeUpdateModal();
                        this.getAd();
                        this.loadLogs();
         
                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Домен успешно обновлен.",
                            color: "success",
                        });
                    },
                    catch: (err) => {
                        debugger
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        if (err.request.status == 422 && err.data.errors) {
                            const error = err.data.errors;
                            return this.$vs.notify({
                                title: "Внимание!",
                                text: error,
                                color: "danger",
                            });   
                        }

                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при обновлении домена!",
                            color: "danger",
                        });
                    }
                })
            },
            showUpdateModal(item) {
                this.selected = item;
                this.$refs.updateModal.open();
            },
            closeUpdateModal(item) {
                this.selected = item;
                this.$refs.updateModal.close();
            },

            setDefaultValues() {
                let endDay = this.$moment(new Date());
                let endDayStr = endDay.format('YYYY-MM-DD ');
                let startDay = endDay.add(-1, 'days');
                let startDayStr = startDay.format('YYYY-MM-DD ');
                let startTime = '00:00:00';
                let endTime = '23:59:59';
                this.dateInterval = [startDayStr + startTime, endDayStr + endTime];
                this.form.dateTimeFrom = this.$moment(this.dateInterval[0]).format('YYYY-MM-DD HH:mm:ss');
                this.form.dateTimeTo = this.$moment(this.dateInterval[1]).format('YYYY-MM-DD HH:mm:ss');
            },
        },
        mounted() {
            this.setDefaultValues();
            this.loadLogs();
        },
        watch: {
            page: function () {
                this.loadLogs();
            },
            dateInterval: function (newTime) {
                this.form.dateTimeFrom = this.$moment(newTime[0]).format('YYYY-MM-DD HH:mm:ss');
                this.form.dateTimeTo = this.$moment(newTime[1]).format('YYYY-MM-DD HH:mm:ss');
            }
        }
    }
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}
thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}
.header-title {
    flex-direction: column;
}
.vs-pagination--mb {
    justify-content: center !important;
}
</style>